/**
 * Check if the value is null or undefined
 * @param value unknown value to check if it is null or undefined
 * @returns true if the value is null or undefined
 *
 * @example
 * isNil(null); // true
 * isNil(undefined); // true
 *
 * function logString(value: string | null) {
 *   if (isNil(value)) {
 *     // value here is typed as null
 *     return;
 *   }
 *   console.log(value); // value here is typed as string
 * }
 */
export function isNil(value: unknown): value is null | undefined {
  return value === null || typeof value === 'undefined';
}
